// src/api/paiementApi.js
import axios from 'axios';

// URL de base de ton API (à adapter selon ton environnement)
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Récupère la liste des paiements depuis l'API.
 * @returns {Promise<Array>} Liste des paiements.
 */
export const fetchPaiements = async () => {
  try {
    const response = await axios.get(`${API_URL}/paiements`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des paiements :", error);
    throw new Error("Impossible de charger les paiements.");
  }
};

/**
 * Met à jour le statut d'un paiement comme "payé".
 * @param {number} id - ID du paiement à mettre à jour.
 * @returns {Promise<Object>} Réponse de l'API.
 */
export const marquerCommePaye = async (id) => {
  try {
    const response = await axios.put(`${API_URL}/paiements/${id}/paye`);
    return response.data;
  } catch (error) {
    console.error(`Erreur lors de la mise à jour du paiement ${id} :`, error);
    throw new Error("Impossible de mettre à jour le paiement.");
  }
};

/**
 * Envoie une relance pour un paiement.
 * @param {number} id - ID du paiement concerné.
 * @returns {Promise<Object>} Réponse de l'API.
 */
export const relancerClient = async (id) => {
  try {
    const response = await axios.post(`${API_URL}/paiements/${id}/relancer`);
    return response.data;
  } catch (error) {
    console.error(`Erreur lors de l'envoi de la relance pour le paiement ${id} :`, error);
    throw new Error("Impossible d'envoyer la relance.");
  }
};
